module.exports = __webpack_public_path__ + "static/media/stop-circle.6e6f14ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stop-circle.svg
// module id = 862
// module chunks = 0